<template>
  <LoginHolder>
    <AlertMessage :alerMessage="alerMessage"></AlertMessage>
    <h2 class="mb-1">Sign in to your account</h2>
    <p class="pb-3">Enter your credentials to access your account.</p>

    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <form
        ma-8
        v-on:submit.prevent>
        <ValidationProvider v-slot="{ errors }" name="Username" rules="required">
          <v-text-field
            v-model="user.username"
            maxlength="100"
            :error-messages="errors"
            label="Username"
            autocomplete="false"
            :disabled="loading"
            required
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider v-slot="{ errors }" name="Password" rules="required">

          <v-text-field
            v-model="user.password"
            :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="errors"
            :type="passShow ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            :disabled="loading"
            autocomplete="false"
            class="input-group--focused mt-3"
            @click:append="passShow = !passShow"
          ></v-text-field>


        </ValidationProvider>
        <v-btn class="d-none" @click="reset"></v-btn>
      </form>
    </ValidationObserver>
    <p class="text-right mb-6 mt-1">
      <router-link class="nav-link text-decoration-none" :to="{ name: 'forgot-password' }">Forgot Password?</router-link>
    </p>
    <v-btn
      depressed
      block
      rounded
      large
      color="primary"
      class="mb-8"
      @click="login()"
      :disabled="loading"
    >
      {{ loading ? 'Please wait...' : 'Sign in' }}
    </v-btn>

    <v-btn
      depressed
      block
      rounded
      large
      :disabled="loading"
      :to="{ name: 'create-new-account' }"
    >
      Create new account
    </v-btn>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </LoginHolder>
</template>

<script>
  import { mapGetters } from "vuex";
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import LoginHolder from './LoginHolder.vue'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  export default {
    name: 'Login',
    data: () => ({
      passShow: false,
      user: {
        username: '',
        password: ''
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false
    }),
    computed: {
    },
    methods: {
      async login(){
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this

        this.$http.secured.post('authenticate', this.user)
          .then(response => {
            this.$store.commit('setCurrentUser', { currentUser: response.data })
            self.$router.push({ name: 'dashboard' })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            self.clear()
          })
          .then(function () {
            self.loading = false
          })
      },
      showLoginDialog (user) {
        this.dialog = {
          show: true,
          title: "Enter "+this.capitalise(user.nickname)+"'s PIN",
          body: '',
          type: 'close',
          user: user,
          confirmBtn: 'Login',
          cancelBtn: 'Cancel'
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      clear () {
        Object.keys(this.user).forEach(key => {
          this.user[key] = ''
        })

        this.$refs.observer.reset()
      },
    },
    mounted() {
    },
    components: {
      SnackBar,
      ValidationProvider,
      ValidationObserver,
      LoginHolder,
      AlertMessage
    },
  }
</script>
